import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Tour from './Tour';
import storage from "../../../../Storage";

class Menus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            runTour: false
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.startTour = this.startTour.bind(this);
        this.handleTourFinish = this.handleTourFinish.bind(this);
    }
    componentDidMount() {
        this.checkSession();
        this.checkRoute();
        if (storage.getKey('start_tour') === 'true') {
            setTimeout(() => {
                this.startTour();
            }, 2000);
            storage.removeKey('start_tour');
        }
        console.log(this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.checkRoute();
        }
    }

    checkRoute() {
        if (this.props.location.pathname === '/how-to-trade') {
            if (!this.state.runTour) {
                this.startTour();
            }
        }
    }

    handleClose() {
        this.setState({ show: false, effect: 'zoomOut' });
        if (this.props.location.pathname === '/how-to-trade') {
            this.props.history.push('/');
        }
    }

    handleShow() {
        this.setState({ show: true, effect: 'zoomIn' });
    }

    startTour() {
        this.setState({ runTour: true, show: false });
    }

    handleTourFinish() {
        this.setState({ runTour: false });
        if (this.props.location.pathname === '/how-to-trade') {
            this.props.history.push('/');
        }
    }

    setCookie(c_name, value, exdays) {
        var exdate = new Date(); exdate.setDate(exdate.getDate() + exdays); var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString()); document.cookie = c_name + "=" + c_value;
    }

    getCookie(c_name) {
        var c_value = document.cookie; var c_start = c_value.indexOf(" " + c_name + "="); if (c_start == -1) { c_start = c_value.indexOf(c_name + "="); } if (c_start == -1) { c_value = null; } else { c_start = c_value.indexOf("=", c_start) + 1; var c_end = c_value.indexOf(";", c_start); if (c_end == -1) { c_end = c_value.length; } c_value = unescape(c_value.substring(c_start, c_end)); } return c_value;
    }

    checkSession() {
        var c = this.getCookie("visited");
        if (c === "yes") {
            //   alert("Welcome back!");
            this.handleClose();
        } else {
            this.setCookie("visited", "yes", 365);
            //   alert("Welcome new visitor!");
            // this.handleShow();
        }
    }


    render() {
        return (
            <>
                <Tour run={this.state.runTour} onFinish={this.handleTourFinish} />
                <span onClick={this.startTour} className={"btn btn-sm bg-cs2 cpt mt-2"} style={{ color: '#fff', padding: '0' }}>
                    <i className={'mdi mdi-information mr-1'} />
                    How To Trade
                </span>
                <Modal
                    size="md"
                    backdrop="static"
                    centered={true}
                    show={this.state.show}
                    onHide={this.handleClose}
                    aria-labelledby="help-md-modal"
                    className="auth-modal-custom animated zoomIn"
                >
                    <Modal.Header>
                        <div className="text-white font-weight-bold">How To Trade</div>
                        <button type="button" className="close p-2" onClick={this.handleClose}>
                            <i className={'mdi mdi-close text-white'} />
                        </button>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <div className="trading-guide-container">
                            <div className="trading-step-card">
                                <div className="step-icon-wrapper step-icon-emerald">
                                    <i className="mdi mdi-cash" />
                                </div>
                                <div className="step-content">
                                    <h6 className="step-title">1. Deposit & Enter Amount to trade</h6>
                                    <p className="step-desc">Enter the amount you want to trade. This is the amount you are looking to multiply.</p>
                                </div>
                            </div>

                            <div className="trading-step-card">
                                <div className="step-icon-wrapper step-icon-sapphire">
                                    <i className="mdi mdi-swap-vertical" />
                                </div>
                                <div className="step-content">
                                    <h6 className="step-title">2. Choose direction BUY or SELL</h6>
                                    <p className="step-desc">Predict where the graph will move next:
                                        <br />
                                        Buy (Up): You win if the graph climbs.
                                        <br />
                                        Sell (Down): You win if the graph drops</p>
                                </div>
                            </div>

                            <div className="trading-step-card">
                                <div className="step-icon-wrapper step-icon-amber">
                                    <i className="mdi mdi-trophy" />
                                </div>
                                <div className="step-content">
                                    <h6 className="step-title">3. Watch & Win in 10 Secs</h6>
                                    <p className="step-desc">Confirm your trade instantly. If the graph moves your way, you win! and vice versa</p>
                                </div>
                            </div>

                            <div className="trading-step-card mb-0">
                                <div className="step-icon-wrapper step-icon-amethyst">
                                    <i className="mdi mdi-trophy-award" />
                                </div>
                                <div className="step-content">
                                    <h6 className="step-title">
                                        WINNING TIP</h6>
                                    <p className="step-desc">Follow Trends: It is often safer to trade with the graph’s momentum than against it.</p>
                                </div>
                            </div>

                            <div className="p-3 text-center border-top border-secondary">
                                <button className="btn btn-success btn-block" onClick={this.startTour}>
                                    <i className="mdi mdi-play-circle-outline mr-2"></i>
                                    Start Interactive Tour
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal >
            </>
        );
    }
}

export default withRouter(Menus);